<div class="form" *appCalendarAppContext>
  <div class="form-date">{{ event?.createdAt | dateFormat : 'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="event"
      [style.color]="event?.color"
    />
    {{ event?.title }}
  </h2>

  @if (event) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="event"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="event"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Calendar</div>
      <div class="form-details-row-input">{{ event?.calendarName || event?.calendarId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Description</div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="event?.description" />
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Start Date</div>
      <div class="form-details-row-input">{{ event?.startTime }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">End Date</div>
      <div class="form-details-row-input">{{ event?.endTime }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">All Day</div>
      <div class="form-details-row-input">{{ event?.allDay }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Reminder</div>
      <div class="form-details-row-input">{{ event?.reminder }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Recurrence</div>
      <div class="form-details-row-input">{{ event?.recurrence | recurrenceText : 'Does Not Repeat' }}</div>
    </div>
  </div>
</div>
